import { render, staticRenderFns } from "./PolicyContent.vue?vue&type=template&id=a8058dcc&scoped=true"
import script from "./PolicyContent.vue?vue&type=script&lang=js"
export * from "./PolicyContent.vue?vue&type=script&lang=js"
import style0 from "./PolicyContent.vue?vue&type=style&index=0&id=a8058dcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8058dcc",
  null
  
)

export default component.exports